<template>
    <div class="mx-auto w-full p-3">
        <a v-if="logo" href="/" class="my-8 sm:pt-12 block">
            <img :src="logoUrl" class="mx-auto w-[160px] h-[47px]" data-test="logo" alt="Voxie" />
        </a>
        <div class="p-6 sm:p-8 bg-slate-50 rounded-2xl shadow border border-white text-slate-700"
            :class="{
                'mt-32': !logo,
            }"
        >
            <div v-if="props.errors?.length"
                class="pb-6">
                <vx-alert color="danger" :closeable="false">
                    <div v-for="(error, index) in props.errors"
                        :key="error"
                        :class="{
                            'pb-1': index + 1 != props.errors.length
                        }">
                        {{ error }}
                    </div>
                </vx-alert>
            </div>
            <slot></slot>
        </div>
    </div>
</template>

<script setup>
import { VxAlert } from '@voxie/frontend-components';
import logoUrl from '@img/logo.png'

const props = defineProps({
    errors: Array,
    logo: {
        type: Boolean,
        default: true,
    }
});

</script>
